const Sms = () =>
  import(
    /* webpackChunkName: "messages-sms" */ '@/pages/message/messages/sms'
  )
const CreateSms = () =>
  import(
    /* webpackChunkName: "messages-sms" */ '@/pages/message/messages/sms/create'
  )
const EditSms = () =>
  import(
    /* webpackChunkName: "messages-sms" */ '@/pages/message/messages/sms/edit'
  )

export default {
  path: 'sms',
  meta: {
    label: 'sms',
    auth: 'sms'
  },
  component: {
    name: 'Sms',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'MessageMessagesSms',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Sms
    },
    {
      name: 'MessageCreateMessagesSms',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSms
    },
    {
      name: 'MessageEditMessagesSms',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSms,
      props: true
    }
  ]
}
